import { format, parseISO } from 'date-fns'
import { MaterialReactTable } from 'material-react-table'
import { useCallback, useEffect, useMemo, useState } from 'react'

import { PageWrap } from '@/components'
import { useTable } from '@/hooks'
import { useDetailTabContext } from '@/pages/User/pages/Home/components/DetailTab'
import { useGetAllNodeHistoryUsingGetQuery } from '@/rtkApi'
import { HistoryDto } from '@/rtkApi/mddApiSliceGenerated'

import { VersionDiffModal } from './components/VersionDiffModal'
import { useVersionsTableColumns } from './hooks'

export const NewVersionsTabV2 = () => {
	const {
		state: { editMode, node },
	} = useDetailTabContext()

	const [diffVersion, setDiffVersion] = useState<number | null>(null)

	const {
		data: tableData,
		isLoading,
		refetch,
	} = useGetAllNodeHistoryUsingGetQuery({
		structureId: node.id,
	})

	useEffect(() => {
		refetch()
		// eslint-disable-next-line react-hooks/exhaustive-deps -- refetch omitted to avoid loop when query ref identity changes
	}, [editMode])

	const dataWithParsedDate = tableData?.map((item) => {
		const parsedDate = parseISO(item.created || '')
		return {
			...item,
			created: format(parsedDate, 'dd.MM.yyyy HH:mm'),
		}
	})

	const latestVersion = useMemo(() => {
		if (!tableData?.length) return 1
		return Math.max(...tableData.map((d) => d.version))
	}, [tableData])

	const onOpenDiff = useCallback((version: number) => {
		setDiffVersion(version)
	}, [])

	const columns = useVersionsTableColumns({ onOpenDiff })

	const table = useTable<HistoryDto>({
		columns,
		data: dataWithParsedDate || [],
		editMode,
		options: {
			enableEditing: true,
			editDisplayMode: 'table',
			enableRowActions: false,
			enableRowOrdering: false,
			state: {
				isLoading,
			},
			enableTopToolbar: true,
			enableGlobalFilter: true,
		},
	})

	return (
		<PageWrap>
			<MaterialReactTable table={table} />
			{diffVersion != null && (
				<VersionDiffModal
					structureId={node.id}
					structureName={node.name ?? node.code}
					historyVersion={diffVersion}
					workingVersion={latestVersion}
					onClose={() => setDiffVersion(null)}
				/>
			)}
		</PageWrap>
	)
}
